import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Zap, WheatOff, DnaOff, Globe } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-40 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-[#FAFAF7]" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-102">
        <div className="text-center max-w-4xl mx-auto" data-id="element-103">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-[#1A1A1A] leading-tight mb-6" data-id="element-104">
            Elimina la Inflamación, Mejora tu Digestión y Transforma tu
            Microbiota —{' '}
            <span className="text-[#1B5E20] italic" data-id="element-105">
              Con el Poder Natural del Amazonas
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg sm:text-xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-106">
            El sistema de bienestar con ingredientes naturales que miles de
            latinos en USA ya usan para sentirse bien desde adentro hacia
            afuera.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-3xl mb-12" data-id="element-107">
            <div className="absolute inset-0 bg-[#4CAF50]/10 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-108"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bG7zi7yRKpY8FpmpvTMJFv/Gemini_Generated_Image_dg5murdg5murdg5m.png" alt="ElixirX Sistema de Bienestar Integral" className="w-full h-auto rounded-3xl object-cover shadow-2xl" fetchPriority="high" data-id="element-109" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-sm sm:text-base font-medium text-[#1A1A1A] mb-10" data-id="element-110">
            <div className="flex items-center" data-id="element-111">
              <Leaf size={18} className="text-[#4CAF50] mr-2" data-id="element-112" /> 100% Natural
            </div>
            <div className="flex items-center" data-id="element-113">
              <Zap size={18} className="text-[#4CAF50] mr-2" data-id="element-114" /> Sin Azúcar
            </div>
            <div className="flex items-center" data-id="element-115">
              <WheatOff size={18} className="text-[#4CAF50] mr-2" data-id="element-116" /> Sin Gluten
            </div>
            <div className="flex items-center" data-id="element-117">
              <DnaOff size={18} className="text-[#4CAF50] mr-2" data-id="element-118" /> Sin GMO
            </div>
            <div className="flex items-center" data-id="element-119">
              <Globe size={18} className="text-[#4CAF50] mr-2" data-id="element-120" /> Del Amazonas
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-121">
            <a href="#paquetes" className="w-full sm:w-auto bg-[#4CAF50] hover:bg-[#1B5E20] text-white text-lg px-10 py-4 rounded-full font-bold transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-center" data-id="element-122">
              ¡Quiero Mi Sistema Ahora!
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex items-center justify-center space-x-2 text-[#1A1A1A] font-medium" data-id="element-123">
            <div className="flex text-[#F9A825]" data-id="element-124">{'★★★★★'}</div>
            <span data-id="element-125">+2,000 familias latinas lo usan</span>
          </motion.div>
        </div>
      </div>
    </section>;
}